






































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Shetai extends Vue {
  @Prop()
  private tongue: any;
  private taise: any[] = ["白", "黄", "黄白相间", "灰黑"];
  private houbao: any[] = ["无", "少", "薄", "稍厚", "厚", "极厚"];
  private taifu: any[] = ["无", "有"];
  private taini: any[] = ["无", "有"];
  private taibo: any[] = ["无剥落", "不匀", "花剥"];
  private pianquan: any[] = ["无偏全", "偏", "全"];
  private jinye: any[] = ["燥苔", "少津", "润苔", "湿苔", "滑苔"];
  private ifShowSeduDetail: boolean = false;
  private cPart: any = "LAB";
  private get t() {
    return this.tongue;
  }
  private set t(val) {
    this.$emit("update:tongue", val);
  }
  private get root() {
    return this.$refs.root as HTMLElement;
  }
  /**
   * @description 根据颜色返回色度值
   */
  private calBackColor(yanse) {
    switch (yanse) {
      case "白":
        return "#D9C6AB";
        break;
      case "黄":
        return "#F9E5C6";
        break;
      case "黄白相间":
        return "#FFECCF";
        break;
      case "灰黑":
        return "#EEE6DA";
        break;
      default:
        return "#ffffff";
    }
  }
  /**
   * @description 打开色度值详情
   */
  private openSeduDetail() {
    this.ifShowSeduDetail = true;
  }
  /**
   * @description 局部舌色特征标注主动滚动到顶
   */
  private jubutaiseScrollToView() {
    const height = (this.$refs.fenbu as HTMLElement).offsetHeight;
    this.root.scroll({ top: height });
  }
  /**
   * @description 删除局部舌色特征标注
   */
  private deleteJubutaise() {
    this.$set(this.t, "局部苔色特征标注", {});
    this.$emit("deleteJubutaise");
  }
  /**
   * @description 局部舌苔放大图主动滚动到顶
   */
  private jubushetaiScrollToView() {
    const height =
      (this.$refs.fenbu as HTMLElement).offsetHeight +
      (this.$refs.seduzhi as HTMLElement).offsetHeight;
    this.root.scroll({ top: height });
  }
  /**
   * @description 删除局部舌苔放大图
   */
  private deleteJubushetai(index) {
    this.t["局部舌苔放大图"].splice(index, 1);
  }
  /**
   * @description 改变部分
   */
  private changeSeduPart(part) {
    this.cPart = part;
  }
}
